<template>
  <svg
    ref="progresscircle"
    class="progress-circle"
    :viewBox="`0 0 ${viewbox.width} ${viewbox.width}`"
  >
    <circle
      fill="transparent"
      :stroke-dasharray="circumference + ' ' + circumference"
      :style="{ strokeDashoffset }"
      :stroke-width="strokeWidth"
      :r="radius"
      :cx="viewbox.width / 2"
      :cy="viewbox.height / 2"
    />
    <polyline
      ref="check"
      fill="transparent"
      :stroke-dasharray="checkDashArray"
      :stroke-dashoffset="checkDashoffset"
      :stroke-width="strokeWidth"
      :points="`${calcPoly('-',.4)},${calcPoly('+',.1)} ${calcPoly('-',.1)},${calcPoly('+',.42)} ${calcPoly('+',.64)},${calcPoly('-',.24)}`"
    />
  </svg>
</template>

<script>
  export default {
    name: 'ProgressCircle',
    props: ['progress', 'stroke'],
    data() {
      return {
        strokeDashoffset: false,
        checkDashoffset: false,
        checkDashArray: 0,
        radius: 0,
        circumference: 0,
        strokeWidth: 0,
        viewbox: {
          width: 100,
          height: 100
        }
      }
    },
    mounted() {
      this.strokeWidth = this.viewbox.width / (this.$refs.progresscircle.getBoundingClientRect().width - (this.stroke * 2)) * this.stroke;
      this.radius = this.viewbox.width / 2 - this.strokeWidth;
      this.circumference = this.radius * 2 * Math.PI;
      this.strokeDashoffset = this.circumference - 0 * this.circumference

      setTimeout(() => {
        this.$refs.progresscircle.querySelector('circle').style.visibility = 'visible';
        this.strokeDashoffset = this.circumference - this.progress * this.circumference
        this.checkDashoffset = this.checkDashArray = this.$refs.progresscircle.querySelector('polyline').getTotalLength();
      }, 1000);
      if (this.progress >= 1) {
        setTimeout(() => {
          this.$refs.progresscircle.classList.add('fullfilled');
          this.$refs.progresscircle.querySelector('polyline').style.visibility = 'visible';
          this.checkDashoffset = 0;
        }, 2000);
      }

    },
    methods: {
      calcPoly(sign, value) {
        if (sign === '-') {
          return this.radius - this.radius * value
        } else {
          return parseFloat(this.radius) + parseFloat(this.radius * value)
        }
      },
      sum(num1, num2) {
        return parseInt(num1) + parseInt(num2);
      }
    }
  }
</script>

<style scoped lang="scss">
  svg {
    stroke: var(--v-primary-base);
    circle {
      visibility: hidden;
      fill: #fff;
      fill-opacity: 0;
      transition: stroke-dashoffset 0.75s, fill-opacity 0.75s;
      transform: rotate(-90deg);
      transform-origin: 50% 50%;
    }
    polyline {
      visibility: hidden;
      transition: stroke-dashoffset 0.35s;
    }
    &.fullfilled {
      circle {
        fill-opacity: .8;
      }
    }
  }
</style>
